import SectionWrapper from '@/components/Landing/SectionWrapper'
import { useEffect, useState } from 'react'
import InfiniteCarousel from './InfiniteCarousel'
import type { LandingInputProps } from './LandingInput'
import LandingInput from './LandingInput'

const Hero = (props: Partial<LandingInputProps>) => {
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    // InfiniteCarousel has a heavy amount of animation, that triggers html diffs.
    // This prevents server side code from attempting to render the carousel.
    setIsMounted(true)
  }, [])

  // Ensure isScrolled is always a boolean
  const { isScrolled = false, isHidden, titleText } = props

  return (
    <SectionWrapper
      className="mx-auto mt-[180px] gap-[20px]"
      title={
        <>
          Powerful AI Tools
          <br />
          For Growth And Marketing
        </>
      }
      description={<>Build or discover AI workflows to automate your work</>}
      between={
        <LandingInput
          isScrolled={isScrolled}
          isHidden={isHidden}
          isFixed={isScrolled}
          titleText={titleText}
        />
      }
    >
      {isMounted && <InfiniteCarousel />}
      {!isMounted && (
        <div className="w-full overflow-hidden">
          <div className="flex animate-pulse gap-4">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="h-[350px] w-[350px] flex-shrink-0 rounded-lg bg-gray-200" />
            ))}
          </div>
        </div>
      )}
    </SectionWrapper>
  )
}

export default Hero
